import { EventBroker } from "@frontend/lib/utils/event-broker";

export const BYNDER_EVENTS = {
    INIT: 'INIT',
    HANDLE_META: 'HANDLE_META',
    HANDLE_ADDITIONAL_PROPERTIES: 'HANDLE_ADDITIONAL_PROPERTIES',
    HANDLE_COPY_TO_BYNDER: 'HANDLE_COPY_TO_BYNDER',
    HANDLE_PUBLISH_ADD_PROPS: 'HANDLE_PUBLISH_ADD_PROPS',
    PUBLISH_INIT: 'PUBLISH_INIT'
};

export const bynderEventBroker = new EventBroker();
